<template>
    <div>
        <loader v-if="isLoading" />
        <table
            v-else
            class="table b-table list table-hover table-borderless"
            id="tbl-contact"
        >
            <thead>
                <tr>
                    <th>Item:</th>
                    <th>Patient:</th>
                    <th>Returned:</th>
                    <th>Restocked:</th>
                    <th>Amount:</th>
                    <th>Invoice:</th>
                    <th>Reason:</th>
                    <th>Notes:</th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="itemCount == 0">
                <tr>
                    <td colspan="9">
                        <i>No records available</i>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(item, index) in list" :key="index">
                    <td>
                        <item-name :item="item.item" :text="item.name" />
                    </td>
                    <td>
                        <patient-name
                            v-if="item.patient"
                            :patient="item.patient"
                        />
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.restock }}</td>
                    <td>{{ _toCurrency(item.return_amount || 0) }}</td>
                    <td>
                        <invoice-link
                            v-if="item.invoice"
                            :invoice="item.invoice"
                            :newTab="false"
                        />
                    </td>
                    <td>
                        {{ item.reason }}
                    </td>
                    <td>{{ item.note }}</td>
                    <td>
                        <span v-if="_hasAccess('billing.return.update')">
                            <i
                                v-if="theReturn.status && isactiveClient"
                                class="cus-page-white-edit cursor-pointer"
                                title="Edit Item"
                                @click="editItem(item)"
                            ></i>
                            <b-dropdown
                                v-else-if="isactiveClient"
                                variant="link"
                                toggle-class="text-decoration-none"
                                no-caret
                                right
                            >
                                <template v-slot:button-content>
                                    <i class="cus-cog-down"></i>
                                </template>
                                <b-dropdown-item
                                    v-if="_hasAccess('billing.return.update')"
                                    href="#"
                                    @click="editItem(item)"
                                >
                                    <i class="cus-page-white-edit"></i>
                                    Edit Item
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="_hasAccess('billing.return.delete')"
                                    href="#"
                                    @click="deleteItem(item)"
                                >
                                    <i class="cus-delete"></i>
                                    Delete Item
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <delete-item ref="modalDeleteItem" @reload="refreshPage"></delete-item>
        <modal-item
            v-if="theReturn"
            ref="modalEditItem"
            modal-ref="modalEditItem"
            :return-details="theReturn"
            @reload="refreshPage"
        />
    </div>
</template>
<script>
/**
 * @name ReturnItems
 * @description List of return's item
 * @see apps/application/views/staff/billing/return/return/sub/item/list.php
 */

import RELATIONS from "@/constants/relations.js";
import ItemName from "@/components/commons/item-name";
import Loader from "@/components/elements/loader-list";
import PatientName from "@/components/commons/patient-name";
import BillingReturnItems from "@/services/billing/billing-return-item";
import DeleteItem from "@/components/return-items/return-item-delete";
import InvoiceLink from "@/components/commons/invoice-link";
import ModalItem from "@/components/return-details/modal-item";

export default {
    components: {
        PatientName,
        ItemName,
        Loader,
        DeleteItem,
        InvoiceLink,
        ModalItem
    },
    data() {
        return {
            isLoading: false,
            list: []
        };
    },
    computed: {
        itemCount() {
            return this.$store.getters["returnDetails/itemCount"];
        },
        theReturn() {
            return this.$store.getters["returnDetails/returnDetails"];
        },
        isactiveClient() {
            let client = this.theReturn.client
                ? this.theReturn.client.single_business_actor
                : null;

            if (client) {
                return (
                    client.isactive &&
                    client.relation_type == RELATIONS.BUSINESS_ACTOR.CLIENT
                );
            }

            return false;
        }
    },
    watch: {},
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            let self = this;
            this.isLoading = true;
            BillingReturnItems.getReturnItems(this.theReturn.id)
                .then(res => {
                    if (res) {
                        self.list = res.resources;

                        this.$store.commit(
                            "returnDetails/setItemCount",
                            self.list.length
                        );
                    } else {
                        throw "Error : Unable to retrieve returns list";
                    }
                })
                .catch(error => {
                    self._message(
                        "Error : Unable to retrieve return item list",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        editItem(item) {
            this.$refs.modalEditItem.open(item);
        },
        deleteItem(item) {
            this.$refs.modalDeleteItem.open(item);
        },
        refreshPage() {
            this.$root.$emit("refresh-return-page");
            this.getList();
        }
    }
};
</script>
